import { render, staticRenderFns } from "./VersionDescriptionViewer.vue?vue&type=template&id=7e7f796e&scoped=true&"
import script from "./VersionDescriptionViewer.vue?vue&type=script&lang=js&"
export * from "./VersionDescriptionViewer.vue?vue&type=script&lang=js&"
import style0 from "./VersionDescriptionViewer.vue?vue&type=style&index=0&id=7e7f796e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7f796e",
  null
  
)

export default component.exports